module.exports = __webpack_public_path__ + "img/sh_qrcode.b14e2fbc.jpg";